import { render, staticRenderFns } from "./VirtualAccountRechargeCheck.vue?vue&type=template&id=51ed443f&scoped=true&"
import script from "./VirtualAccountRechargeCheck.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountRechargeCheck.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountRechargeCheck.vue?vue&type=style&index=0&id=51ed443f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed443f",
  null
  
)

export default component.exports